import { Box, Button, Badge, Avatar, Flex, FlexItem } from "orcs-design-system";
import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import { get } from "lodash";

import { getMemberCountDisplay } from "src/util/search";
import { AvatarWithGradient, getTeamGradient } from "src/util/gradient";
import { OptionValuePropType } from "src/custom-prop-types/search";
import { getGroupBgImg } from "src/util/group";
import useGetBranding from "src/hooks/useGetBranding";
import { getMemberCount } from "src/queries/group.graphql";

const TeamFormatOptionLabel = ({ value, alreadyInGroup, group }) => {
  const { data } = useQuery(getMemberCount, {
    variables: {
      groupId: group?.id,
    },
    fetchPolicy: "cache-and-network",
    skip: !group?.id || value.message,
  });

  const branding = useGetBranding();

  if (value.message) {
    return (
      <Box p="s" bg="transparent" width="100%">
        {value.message}
      </Box>
    );
  }

  const memberCount = get(data, "group.memberCount");
  const subtitleContent = memberCount ? getMemberCountDisplay(memberCount) : "";
  const team = group;
  const bgImg = getGroupBgImg(team);
  const bgGradient = getTeamGradient(branding, team);

  const { name } = team;
  const AvatarComponent = bgImg ? Avatar : AvatarWithGradient;

  const badge = alreadyInGroup ? (
    <Badge variant="success">Assigned</Badge>
  ) : (
    <Button small>Assign</Button>
  );
  return (
    <Box bg="transparent" width="100%">
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        <FlexItem flex="1 1 auto">
          <AvatarComponent
            shape="square"
            sizing="small"
            title={name}
            subtitleContent={subtitleContent}
            image={bgImg}
            bgGradient={bgImg ? undefined : bgGradient}
          />
        </FlexItem>
        <FlexItem flex="0 0 auto" ml="s">
          {badge}
        </FlexItem>
      </Flex>
    </Box>
  );
};

TeamFormatOptionLabel.propTypes = {
  value: OptionValuePropType,
  alreadyInGroup: PropTypes.bool,
  group: OptionValuePropType,
};

export default TeamFormatOptionLabel;
